import React, { useState, useEffect } from "react";
import {
  getAllByClanakId,
  getCountAll,
} from "../../services/statistikaClanka.service";
import clanakService from "../../services/clanak.service";
import ChartClanak from "./ChartClanak";
import PosjecenostClankaOdNastankaChart from "./PosjecenostClankaOdNastankaChart";
import { Row, Col, Button, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import SearchBar from "../../components/SearchBar";
import "./PosjecenostClanka.css";

const PosjecenostClanka = () => {
  const [clanakId, setClanakId] = useState(null);
  const [brojPosjeta, setBrojPosjeta] = useState(0);
  const [ukupnoPosjeta, setUkupnoPosjeta] = useState(0);
  const [clanci, setClanci] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filtriraniClanci, setFiltriraniClanci] = useState([]);

  useEffect(() => {
    const ucitajClanke = async () => {
      try {
        const { data } = await clanakService.getAll();
        setClanci(data);
      } catch (error) {}
    };
    ucitajClanke();
  }, []);

  const dohvatiStatistiku = async (idClanka) => {
    if (!idClanka) return;

    setLoading(true);
    setClanakId(idClanka);

    try {
      const { data } = await getAllByClanakId(idClanka);
      setBrojPosjeta(data.length);

      const ukupnaPosjetaResponse = await getCountAll();
      setUkupnoPosjeta(ukupnaPosjetaResponse.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchTerm) {
      setFiltriraniClanci([]);
      setClanakId(null);
      return;
    }

    const rezultati = clanci.filter((c) =>
      c.naslov.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltriraniClanci(rezultati);

    const exactMatch = clanci.find(
      (c) => c.naslov.toLowerCase() === searchTerm.toLowerCase()
    );
    if (exactMatch) {
      setClanakId(exactMatch.id);
      dohvatiStatistiku(exactMatch.id);
      setFiltriraniClanci([]);
    }
  }, [searchTerm, clanci]);

  const handleDropdownSelect = (id) => {
    const selectedClanak = clanci.find((c) => c.id === id);
    if (selectedClanak) {
      setClanakId(selectedClanak.id);
      setSearchTerm(selectedClanak.naslov);
      dohvatiStatistiku(selectedClanak.id);
      setFiltriraniClanci([]);
    }
  };

  const articleMenu = (
    <Menu>
      {clanci.map((clanak) => (
        <Menu.Item
          key={clanak.id}
          onClick={() => handleDropdownSelect(clanak.id)}
        >
          {clanak.naslov}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="posjecenost-clanaka-div">
      <Row
        className=".posjecenost-clanka-row.ant-row"
        align="middle"
        justify="center"
        gutter={[16, 16]}
      >
        <Col xs={24} sm={12}>
          <div className="searchbar-wrapper" style={{ width: "100%" }}>
            <Dropdown
              overlay={articleMenu}
              trigger={["click"]}
              disabled={loading}
              overlayClassName="dropdown-clanak-menu"
            >
              <Button className="ant-dropdown-button" style={{ width: "100%" }}>
                {clanakId
                  ? clanci.find((c) => c.id === clanakId)?.naslov ||
                    "Odaberite članak"
                  : "Odaberite članak"}{" "}
                <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="searchbar-wrapper" style={{ width: "100%" }}>
            <SearchBar
              searchTitle={searchTerm}
              setSearchTitle={setSearchTerm}
              placeholder="Pretraži članak po nazivu..."
            />
          </div>
        </Col>
      </Row>

      {searchTerm && filtriraniClanci.length > 0 && (
        <ul>
          {filtriraniClanci.map((clanak) => (
            <li
              key={clanak.id}
              onClick={() => {
                setSearchTerm(clanak.naslov);
                handleDropdownSelect(clanak.id);
              }}
            >
              {clanak.naslov}
            </li>
          ))}
        </ul>
      )}

      {loading ? (
        <div>Učitavanje...</div>
      ) : clanakId ? (
        <>
          <Row justify="center">
            <Col>
              <div className="posjecenost-clanka-div2">
                <h3 className="posjecenost-clanaka-h3">
                  Ukupan broj posjeta članka:
                </h3>
                <p>{brojPosjeta}</p>
              </div>
            </Col>
          </Row>

          <Row
            gutter={[16, 16]}
            justify="center"
            align="middle"
            style={{ width: "100%" }}
          >
            <Col xs={24} md={12} className="chart-col">
              <ChartClanak clanakId={clanakId} />
            </Col>
            <Col xs={24} md={12} className="chart-col">
              <PosjecenostClankaOdNastankaChart clanakId={clanakId} />
            </Col>
          </Row>
        </>
      ) : (
        <div className="posjecenost-clanka-tekst">
          <p>Odaberite članak ili unesite naziv u pretragu. </p>
        </div>
      )}
    </div>
  );
};

export default PosjecenostClanka;
